import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule } from '@spartacus/core';
import {
  GlobalMessageComponentModule,
  IconModule,
  KeyboardFocusModule,
  OutletModule,
  OutletPosition,
  OutletRefModule,
  OutletService,
  PageLayoutModule,
  PageSlotModule,
  provideOutlet,
  SkipLinkModule
} from '@spartacus/storefront';
import { UigPipesModule } from 'src/app/pipes/uig-pipes.module';
import { UigOutletsService } from '../uig-product/services/uig-outlets.service';
import { UigGlobalMessageComponent } from './uig-global-message/uig-global-message.component';
import { UigHeaderComponent } from './uig-header.component';



@NgModule({
  declarations: [
    UigHeaderComponent,
    UigGlobalMessageComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    GlobalMessageComponentModule,
    OutletModule,
    OutletRefModule,
    PageLayoutModule,
    PageSlotModule,
    KeyboardFocusModule,
    SkipLinkModule,
    IconModule,
    I18nModule,
    UigPipesModule,
  ],
  providers: [
    {provide: OutletService,
      useClass: UigOutletsService
    },
    provideOutlet({
      id: 'cx-header',
      position: OutletPosition.REPLACE,
      component: UigHeaderComponent,
    }),
  ]
})
export class UigHeaderModule { }
